<template>
  <div class="packages-landing">
    <section class="section intro">
      <div class="container">
        <div class="row">
          <div class="col-md-4 white text-center text-sm-left">
            <h1 class="m-t-0">Find a solution that works for your practice</h1>
            <p class="lead">From only R119 per month, you can move your practice into the digital age. Join the LogBox community today.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section bg-primary pricing-plans">
      <div class="container">
        <div class="row">
          <div class="col-sm-4">
            <div class="pricing-box z-depth-2">
              <div class="pricing-title">
                <h3>Single Practice</h3>
              </div>
              <div class="pricing-price">
                <span class="price-unit">R</span>119<span class="price-tenure">/month</span>
              </div>
              <div class="pricing-features">
                <ul>
                  <li>Fewer than 10 users.</li>
                  <li>For every additional user, R10/month per user.</li>
                </ul>
              </div>
              <div class="pricing-action">
                <router-link to="/signup" class="btn btn-primary btn-block btn-flat">30 Day Free Trial</router-link>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="pricing-box z-depth-2">
              <div class="pricing-title">
                <h3>Integrated Billing</h3>
              </div>
              <div class="pricing-price">
                <span class="price-unit">R</span>250<span class="price-tenure">/month</span>
              </div>
              <div class="pricing-features" style="padding-top:20px ;padding-bottom: 12px">
                <ul>
                  <li>Integrated with your current billing software</li>
                </ul>
              </div>
              <div class="pricing-action">
                <router-link to="/signup" class="btn btn-primary btn-block btn-flat">30 Day Free Trial</router-link>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="pricing-box z-depth-2">
              <div class="pricing-title">
                <h3>Group Practice</h3>
              </div>
              <div class="pricing-price">
                <img src="~assets/images/brochure/professional/5.png" class="group-practice-icon">
              </div>
              <div class="pricing-features" style="padding-bottom: 10px">
                <ul>
                  <li>Contact us and we'll be in touch.</li>
                </ul>
              </div>
              <div class="pricing-action">
                <a href="mailto:contact@logbox.co.za" class="btn btn-primary btn-block btn-flat">Contact Us</a>
              </div>
            </div>

          </div>
        </div>
        <div class="row text-center m-t-lg" style="color:white;">
          Please note all packages are subject to <a @click="openModal" style="color:white;text-decoration: underline">Terms and Conditions</a>
        </div>
      </div>
    </section>

    <section class="">
      <div class="container-fluid">
        <div class="row flush">
          <div class="col-md-4 grey-1">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Patient</h3>
              <p class="">LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.</p>
              <router-link to="/patient" class="btn btn-default">Learn More</router-link>
            </div>
          </div>
          <div class="col-md-4 grey-2">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Practice</h3>
              <p class="">Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.</p>
              <router-link to="/practice" class="btn btn-default">Learn More</router-link>
            </div>
          </div>
          <div class="col-md-4 grey-3">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Academic</h3>
              <p class="">A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.</p>
              <router-link to="/academic" class="btn btn-default">Learn More</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <ud-terms-modal :open="modalOpen" @close="closeModal"></ud-terms-modal>
  </div>
</template>

<script>
  import PartnerBranding from 'components/common/PartnerBranding';

  export default {
    name: 'packages',
    components: {
      UdTermsModal: () => import('components/common/modals/UdTermsModal'),
      PartnerBranding,
    },
    data: () => ({
      modalOpen: false,
    }),
    methods: {
      openModal() {
        this.modalOpen = true;
      },
      closeModal() {
        this.modalOpen = false;
      },
    },
  };

</script>

<style scoped>
  .group-practice-icon {
    filter: invert(100%);
  }
</style>



// WEBPACK FOOTER //
// Packages.vue?0f5cc1d0